export default __webpack_public_path__ + "static/media/grayPencil.4c8f22ca.svg";